import React, { ReactNode } from 'react';
import styled from 'styled-components';

// Material UI
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';

// Components
import DashboardSidebar from './dashboard-sidebar.component';
import { DashboardNav } from './dashboard-nav.component';
import { useIsNavCollapsed, useIsContextCollapsed } from '../../../../lib/stores/dashboard-layout.store';
import OnlineStatus from '../../../_core/OnlineStatus/online-status.component';
import { AssessmentSelectorLayout } from './assessment-selector.layout';
import { useUsetifulTags } from '../../../../lib/hooks/useUsetifulTags';

interface DashboardProps {
  children: ReactNode;
  hideAssessmentSelector?: boolean;
  hideSidebar?: boolean;
  hideAgeGroupFilter?: boolean;
  requiredRoles?: string[]
}

const FullMainWrapper = styled.div`
  box-shadow: 0 0 24px 8px rgba(0,0,0,0.05);
  padding: 24px;
  background: #fff;
  height: auto;
  min-height: 100%;
`

const DashboardLayout: React.FC<DashboardProps> = ({ children, hideAssessmentSelector, hideSidebar, hideAgeGroupFilter, requiredRoles }) => {
  const isNavCollapsed = useIsNavCollapsed();
  const isContextCollapsed = useIsContextCollapsed();

  // Set Usetiful tags for authenticated users accessing dashboard
  useUsetifulTags();

  let content = (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box pb={3}>{children}</Box>
      </Grid>
    </Grid>
  );

  if (hideSidebar) {
    content = (
      <Box flexGrow={1} pl={isNavCollapsed ? 8 : 22.5} boxSizing="border-box" maxWidth="100%">
        <FullMainWrapper>
          {!hideAssessmentSelector &&
            <Box width="300px" display="flex" alignItems="center">
              <AssessmentSelectorLayout requiredRoles={requiredRoles} />
            </Box>
          }
          <Box>{content}</Box>
        </FullMainWrapper>
      </Box>
    )
  } else {
    let pl = 64.375;
    if (isNavCollapsed) pl -= 14.5;
    if (isContextCollapsed) pl -= 35.875;

    content = (
      <Box px={4} py={2} flexGrow={1} pl={pl} boxSizing="border-box" maxWidth="100%">
        {content}
      </Box>
    );
  }

  return (
    <>
      <OnlineStatus />
      <Box display="flex" height="100%" width="100%">
        <DashboardNav />
        {!hideSidebar && <DashboardSidebar requiredRoles={requiredRoles} hideAgeGroupFilter={hideAgeGroupFilter} />}
        {content}
      </Box>
    </>
  );
};

export default DashboardLayout;
